var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.title}},[(_vm.value)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("mdi-check")]):_c('v-icon',{attrs:{"color":_vm.falseColor}},[_vm._v("mdi-close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }